import React, { useEffect, useState } from 'react';
import { validateTreeName } from '../tree-domain/treeNameValidation';

interface RenameTreeModalProps {
  isOpen: boolean;
  initialName: string;
  onClose: () => void;
  onConfirm: (trimmedName: string) => void;
}

export const RenameTreeModal: React.FC<RenameTreeModalProps> = ({
  isOpen,
  initialName,
  onClose,
  onConfirm,
}) => {
  const [value, setValue] = useState(initialName);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isOpen) {
      setValue(initialName);
      setError(null);
    }
  }, [isOpen, initialName]);

  if (!isOpen) {
    return null;
  }

  const isNameValid = validateTreeName(value) === null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const validationError = validateTreeName(value);
    if (validationError) {
      setError(validationError);
      return;
    }
    onConfirm(value.trim());
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Rename tree</h2>
          <button type="button" className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="rename-tree-name">Tree name</label>
              <input
                id="rename-tree-name"
                type="text"
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                  setError(null);
                }}
                className={`form-input ${error ? 'form-input-error' : ''}`}
                autoFocus
                autoComplete="off"
              />
              {error && <div className="form-error">{error}</div>}
            </div>
            <div className="form-actions">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={!isNameValid}>
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
